import { AnyAccountId, RoomContextId, StreamSpecs } from "@common/domain";
import { RoomStreamVO } from "@youm-front/room/domain";

/**
 * The stage streams this page plays the sound of. Never this page's own
 * camera/microphone: played back, the user hears himself (2026-11-03, session
 * 839721: a guest whose page lost its token heard only his own voice, the
 * account check alone no longer recognized his stream). The room context of
 * the page identifies its own streams without any token.
 */
export function stageAudibleStreams(
  stageStreams: RoomStreamVO[],
  accountId: null | undefined | AnyAccountId,
  roomContextId: RoomContextId
): RoomStreamVO[] {
  return stageStreams.filter(
    (_) =>
      StreamSpecs.isAudiable(_.value.streamId, _.value.accountId, accountId) &&
      !(
        StreamSpecs.isOfType(_.value.streamId, "camMic") &&
        _.value.roomContextId === roomContextId
      )
  );
}
